export enum AppRoutes {
  MAIN = 'main',
  LOGIN = 'login',
  INDIA_LANDING = 'india_landing',
  RUSSIA_LANDING = 'russia_landing',
  RUSSIA_ONBOARDING_SUCCESS = 'russia_onboarding_success',
  RUSSIA_EXISTING_ACCOUNT = 'russia_existing_account',
  SETUP = 'setup',
  RUSSIA_ACCOUNT = 'russia_account',
  RUSSIA_LOGIN = 'russia_login',
  RUSSIA_OTP_CHECK = 'russia_otp_check',
  RUSSIA_SUCCESSFUL_PAYMENT = 'russia_successful_payment',
  RUSSIA_STRIPE_CALLBACK = 'russia_stripe_callback',
  RUSSIA_PAYMENT_RETURN = 'russia_payment_return',
  PAYMENT_RETURN = 'payment_return',
  SIGN_UP = 'sign_up',
  SUCCESSFUL_PAYMENT = 'successful_payment',
  OTP_CHECK = 'otp_check',
  TEST = 'test',
  STRIPE_CALLBACK = 'stripe',

  // last
  NOT_FOUND = 'not_found',
}

export const isRussiaRoute = (pathname: string) =>
  /^\/ru(?:\/|$)/.test(pathname);

// Route selection follows the current RU flow, never the interface language.
const regionalPath = (globalPath: string, ruPath: string, pathname: string) =>
  isRussiaRoute(pathname) ? ruPath : globalPath;

export const getRouteRussiaAccount = () => '/ru/account';
export const getRouteRussiaLogin = () => '/ru/login';
export const getRouteRussiaOtpCheck = () => '/ru/otpcheck';
export const getRouteRussiaSuccessfulPayment = () => '/ru/successful-payment';
export const getRouteRussiaPaymentReturn = () => '/ru/payment-return';
export const getRoutePaymentReturn = () => '/payment-return';
export const getRouteMain = (pathname = window.location.pathname) =>
  regionalPath('/', getRouteRussiaAccount(), pathname);
export const getRouteConnections = () => `/connections`;
export const getRoutePayment = () => `/payment`;
export const getRouteSupport = () => `/support`;
export const getRouteLogin = (pathname = window.location.pathname) =>
  regionalPath('/login', getRouteRussiaLogin(), pathname);
export const getRouteIndiaLanding = () => `/in`;
export const getRouteRussiaLanding = () => `/ru`;
export const getRouteRussiaOnboardingSuccess = () => `/ru/onboarding`;
export const getRouteRussiaExistingAccount = () => `/ru/registered`;
export const getRouteSetup = () => `/setup`;
export const getSignUp = (pathname = window.location.pathname) =>
  regionalPath('/sign-up', '/ru', pathname);
export const getRouteSuccessfulPayment = (
  pathname = window.location.pathname
) =>
  regionalPath(
    '/successful-payment',
    getRouteRussiaSuccessfulPayment(),
    pathname
  );
export const getRouteOtpCheck = (pathname = window.location.pathname) =>
  regionalPath('/otpcheck', getRouteRussiaOtpCheck(), pathname);
export const getRouteTest = () => undefined; //`/test`;
export const getRouteStripeCallback = () => `/callback/stripe`;
